<figure class="logo"><img src="{{ assetsConst.Logo }}" alt="logo" /></figure>
<div class="form_feilds">
  <h2 class="text_center mb_30">
    <button class="reset_btn btnn bck_bt" type="button" (click)="closeDialog()">
      <i class="fa fa-arrow-left" aria-hidden="true"></i>
    </button>
    {{ 'enterOTP' | translate }}
  </h2>
  <div class="timer-container" *ngIf="!sendagain">
    <p>
      {{ 'Time' | translate }} {{ 'remaining' | translate }}:
      <span> {{ otpTimer }}</span>
    </p>
  </div>
  <div class="gap_m form_feilds_wrp">
    <div class="form_group w_100">
      <ng-otp-input [config]="{ length: 4 }" #ngOtpInput></ng-otp-input>
    </div>
  </div>
  <div class="submit_btn">
    <a class="btnn btn_primary" (click)="otpChange()">
      {{ 'Verify' | translate }}
    </a>
  </div>
  <div class="lgin_si sigup mt_20" *ngIf="sendagain">
    <p>
      {{ 'Didnt' | translate }} {{ 'receiveOTP' | translate }}?
      <span (click)="resendOtp()">{{ 'Resend' | translate }}</span>
    </p>
  </div>
</div>
